export const normalizeSearch = value => String(value ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

// Index only the fields useful for this list. Weak keys release old API records.
const indexes = new WeakMap();
function valuesAt(record, path) {
  if (Array.isArray(record)) return record.flatMap(value => valuesAt(value, path));
  if (!path.length) return record != null && typeof record !== 'object' ? [record] : [];
  return record == null ? [] : valuesAt(record[path[0]], path.slice(1));
}
export function createListSearch(query, fields) {
  const terms = normalizeSearch(query).split(/\s+/).filter(Boolean);
  const key = fields.join('|');
  const paths = fields.map(field => field.split('.'));
  return record => {
    if (!terms.length) return true;
    if (!record || typeof record !== 'object') return false;
    let cache = indexes.get(record);
    if (!cache) { cache = new Map(); indexes.set(record, cache); }
    let index = cache.get(key);
    if (!index) {
      const values = paths.flatMap(path => valuesAt(record, path)).map(normalizeSearch);
      index = { text: values.join(' '), compact: values.map(value => value.replace(/[\s().-]/g, '')).join(' ') };
      cache.set(key, index);
    }
    return terms.every(term => index.text.includes(term) || (/^[+\d().-]+$/.test(term) && index.compact.includes(term.replace(/[().-]/g, ''))));
  };
}
